"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAvailable = void 0;
function isAvailable() {
    return typeof window !== 'undefined' && typeof window['mozPaintCount'] !== 'undefined';
}
exports.isAvailable = isAvailable;
//# sourceMappingURL=mozpaintcount-pixel.js.map